


































import { mixins } from 'vue-class-component'
import { Component } from 'vue-property-decorator'
import { DialogModalLayout } from '@/components/modals/layouts'
import { ModalComponentMixin } from '@/mixins/modal'


@Component({
  components: {
    DialogModalLayout,
  },
})
export default class ComponentModalConfirmarFluxoAlteracaoOrcamento extends mixins(ModalComponentMixin) {
  selected: string = 'BackofficeAlteraOrcamento';

  options = [
    {
      label: 'Alterar o orçamento e manter a situação atual',
      value: 'BackofficeAlteraOrcamento',
    },
    {
      label: 'Alterar o orçamento e retornar para o início do processo',
      value: 'BackofficeAlteraOrcamentoESegueParaNovoOrcamentoParticular',
    },
    {
      label: 'Alterar o orçamento e enviar novo orçamento ao médico',
      value: 'BackofficeAlteraOrcamentoESegueParaAguardandoOrcamento',
    },
  ]
}
